import { IDeviceTabletItem } from '@/services/api/api.type';

import { formatDate } from 'utils';

type TFormatListParams = {
	total: number;
	page: number;
	pageSize: number;
};

export const formatDeviceTabletDetail = (
	input: IDeviceTabletItem,
	index: number,
	params: TFormatListParams
) => {
	return {
		...input,
		no: params.total - (params.page - 1) * params.pageSize - index,
		registeredAt: formatDate(input.registeredAt),
		validFrom: formatDate(input.validFrom),
		validUntil: formatDate(input.validUntil),
	};
};

export const formatDeviceTabletList = (
	input: IDeviceTabletItem[],
	params: TFormatListParams
) => {
	return input.map((item, index) =>
		formatDeviceTabletDetail(item, index, params)
	);
};
